"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageFileSize = void 0;
var react_1 = __importDefault(require("react"));
var filesize_1 = __importDefault(require("filesize"));
var PackageFileSize = function (props) {
    var text = props.size === 0 ? '--' : filesize_1.default(props.size);
    return react_1.default.createElement("span", null, text);
};
exports.PackageFileSize = PackageFileSize;
